import { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import { Response } from './types';
import { message } from 'antd';
import { NETWORK_ERROR_MESSAGE, TOKEN_EXPIRED_MESSAGE, UNAUTHENCATIED_MESSAGE } from '../../config/strcfg';
import umbrella from 'umbrella-storage';
import Cookies from 'js-cookie';

const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://www.heartyconsulting.com/crmservice' : 'http://localhost:8080/crmservice'; 
let handlingUnauthorized = false;

class HTTP {
    config: AxiosRequestConfig = {
        baseURL: BASE_URL,
        withCredentials: true
    };


    handleLogout = () => {
        umbrella.removeLocalStorage('user');
        Cookies.remove('token', { path: '/' });
        Cookies.remove('userRole', { path: '/' });
    }

    handleUnauthorized = () => {
        if (handlingUnauthorized) {
            return;
        }
        handlingUnauthorized = true;

        message.error(TOKEN_EXPIRED_MESSAGE);
        this.handleLogout();

        const hash = window.location.hash || '';
        if (!hash.startsWith('#/login')) {
            window.location.href = '/#/login';
        } else {
            window.location.reload();
        }

        setTimeout(() => {
            handlingUnauthorized = false;
        }, 1000);
    };
    handleError(error: any){
        if (error.response) {
            if(error.response.status === 401){
                this.handleUnauthorized();
            } else if(error.response.status === 403){
                const hasLocalUser = !!umbrella.getLocalStorage('user');
                const hasRoleCookie = !!Cookies.get('userRole');
                if (hasLocalUser && !hasRoleCookie) {
                    this.handleUnauthorized();
                    return;
                }
                message.error(UNAUTHENCATIED_MESSAGE);
            }
        } else {
            message.error(NETWORK_ERROR_MESSAGE + error);
        }
    };
      
    private getConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
        return Object.assign({}, this.config, config || {});
    }

    protected async get(url: string, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.get(url, this.getConfig(config));
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async post(url: string, data?: any, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.post(url, data, this.getConfig(config));
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async delete(url: string, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.delete(url, this.getConfig(config));
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async put(url: string, data?: any, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.put(url, data, this.getConfig(config));
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async patch(url: string, data?: any, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.patch(url, data, this.getConfig(config));
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async request(config: AxiosRequestConfig) {
        try {
            const res: Response<any> = await axios.request(config);
            if (res.data.code === 401) {
                this.handleUnauthorized();
            }
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async head(url: string, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.head(url, config);
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }
    
    protected async options(url: string, config?: AxiosRequestConfig) {
        try {
            url = BASE_URL + url;
            const res: Response<any> = await axios.options(url, config);
            if (res.data.code === 403) {
                this.handleError({ response: { status: 403, data: res.data } });
            }
            return res;
        } catch (error) {
            this.handleError(error);
        }
    }


}
export default HTTP;
